import { SECURITY_SCREEN_NAME } from '@/common/screenNames'

const TheContainer = () => import('@/containers/TheContainer')
const SecuritySettings = () => import('@/views/account/SecuritySettings')

/**
 * F5・直リンクより前に本人用セキュリティ画面を登録する。
 *
 * 個人設定と同じ扱い。**ログイン済みの本人だけ**が開ける。
 * サーバ側でも公開パスに入れていないので、画面だけを直接叩いても
 * 中身は返らない。画面の出し分けとサーバの守りを、両方そろえておく。
 */
export default function registerSecuritySettingsRoutes (router) {
  router.addRoutes([
    {
      path: '/my',
      component: TheContainer,
      children: [
        {
          path: 'security',
          name: SECURITY_SCREEN_NAME,
          component: SecuritySettings,
          meta: { requiresAuth: true, personalSettings: true }
        }
      ]
    }
  ])
}
